import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config/api';
import { useSubscription } from '../../context/SubscriptionContext';
import './PaymentResultPage.css';

const PaymentResultPage = ({ status }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshSubscription } = useSubscription();
  const [verifying, setVerifying] = useState(status === 'success');
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');

  const gateway = searchParams.get('gateway') || '';
  const sessionId = searchParams.get('session_id') || '';
  const orderId = searchParams.get('orderId') || '';

  useEffect(() => {
    if (status === 'success' && gateway === 'stripe' && sessionId) {
      verifyStripePayment();
    } else if (status === 'success') {
      // For Paytm callback-based, backend already verified
      setVerifying(false);
      setVerified(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifyStripePayment = async () => {
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('specialist_token');
      await axios.post(`${API_URL}/payment-gateway/verify`, {
        gateway: 'stripe',
        paymentData: { session_id: sessionId }
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVerified(true);
      // Refresh subscription context so plan features update immediately
      if (refreshSubscription) await refreshSubscription();
    } catch (err) {
      setError('Payment verification failed. Please contact support.');
    } finally {
      setVerifying(false);
    }
  };

  const isSuccess = status === 'success' && (verified || !verifying);

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        {verifying ? (
          <>
            <div className="payment-result-icon verifying">⏳</div>
            <h1>Verifying Payment...</h1>
            <p>Please wait while we confirm your payment.</p>
          </>
        ) : isSuccess && !error ? (
          <>
            <div className="payment-result-icon success">✓</div>
            <h1>Payment Successful!</h1>
            <p>Your payment has been processed successfully. Your account will be updated shortly.</p>
            {gateway && <p className="payment-result-gateway">Paid via {gateway.charAt(0).toUpperCase() + gateway.slice(1)}</p>}
          </>
        ) : (
          <>
            <div className="payment-result-icon failed">✕</div>
            <h1>Payment {status === 'cancel' ? 'Cancelled' : 'Failed'}</h1>
            <p>{error || 'Your payment was not completed. No charges have been made.'}</p>
          </>
        )}

        <div className="payment-result-actions">
          <button onClick={() => navigate('/vendor-dashboard')} className="payment-result-btn primary">
            Go to Dashboard
          </button>
          <button onClick={() => navigate('/membership-packages')} className="payment-result-btn secondary">
            Back to Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResultPage;
